__turbopack_context__.v({
  "card": "xQCAfG_card",
  "content": "xQCAfG_content",
  "header": "xQCAfG_header",
  "image": "xQCAfG_image",
});
